var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vm-card',{staticClass:"content-register"},[_c('div',{staticClass:"box-register"},[_c('span',{staticClass:"text-gray"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"numbers"},[_vm._v(_vm._s(_vm.number))])])])}
var staticRenderFns = []

export { render, staticRenderFns }